<template>
  <div id="app">
    <div>
      <mdb-navbar expand="large" dark color="elegant-color">
        <mdb-navbar-brand href="#">
          <img src="@/assets/Hypertech-logo.png" height="40" alt="Hypertech">
        </mdb-navbar-brand>
        <mdb-navbar-toggler>
          <mdb-navbar-nav right>
            <mdb-nav-item href="#"><router-link to="/"><div>Home</div></router-link></mdb-nav-item>
            <mdb-nav-item href="#"><router-link to="/products">Products</router-link></mdb-nav-item>
            <mdb-nav-item href="#"><router-link to="/portfolio">Portfolio</router-link></mdb-nav-item>
            <mdb-dropdown tag="li" class="nav-item marginLeft">
              <mdb-dropdown-toggle tag="a"  color="fancy" slot="toggle" waves-fixed ><a href="#">More</a></mdb-dropdown-toggle>
              <mdb-dropdown-menu>
                <mdb-dropdown-item  to="/blog"><div class="zero">Blog</div></mdb-dropdown-item>
                <mdb-dropdown-item >Popular</mdb-dropdown-item>
                <mdb-dropdown-item >Comments</mdb-dropdown-item>
              </mdb-dropdown-menu>
            </mdb-dropdown>
          </mdb-navbar-nav>
        </mdb-navbar-toggler>
      </mdb-navbar>
    </div>
    <router-view/>
  </div>
</template>

<script>
import mdbDropdown from 'mdbvue/lib/components/mdbDropdown'
import mdbDropdownToggle from 'mdbvue/lib/components/mdbDropdownToggle'
import mdbDropdownMenu from 'mdbvue/lib/components/mdbDropdownMenu'
import mdbDropdownItem from 'mdbvue/lib/components/mdbDropdownItem'
import mdbNavbarBrand from 'mdbvue/lib/components/mdbNavbarBrand'
import mdbNavbarToggler from 'mdbvue/lib/components/mdbNavbarToggler'
import mdbNavbar from 'mdbvue/lib/components/mdbNavbar'
import mdbNavbarNav from 'mdbvue/lib/components/mdbNavbarNav'
import mdbNavItem from 'mdbvue/lib/components/mdbNavItem'

export default {
  name: 'App',
  components: {
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbar,
    mdbNavbarNav,
    mdbNavItem
  },
  metaInfo: {
    title: 'Hypertech',
    meta: [
      { name: 'home page', content: 'Hypertech ICT consultants' },
      { name: 'keywords', content: 'hypertech,ICT,networking' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, shrink-to-fit=no' }
    ]
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');

$image-path: '~@/../mdb/mdbvue/img';
@import '~@/../mdb/mdbvue/scss/mdb-free.scss';

@import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');
.marginLeft{
  padding-right: 30px;
}
</style>
